import { DASHBOARD_TASKS, defineModule } from "@motolynk/app-core";

import { JobTasks } from "./admin/dashboard";
import en from "./i18n/en.json";

export const opsModule = defineModule({
  name: "ops",
  label: "Operations",
  requires: ["core", "accounts"],
  i18n: { en },
  admin: {
    routes: [
      {
        path: "system/jobs",
        permission: "core.view_failedjob",
        page: () => import("./admin/JobsPage"),
      },
    ],
    nav: [
      {
        id: "jobs",
        group: "settings",
        label: "ops:nav.jobs",
        icon: "refresh",
        to: "/system/jobs",
        permission: "core.view_failedjob",
        order: 8,
      },
    ],
    slots: {
      [DASHBOARD_TASKS]: [
        { id: "jobs", permission: "core.view_failedjob", order: 90, component: JobTasks },
      ],
    },
  },
});
